import React, { ChangeEvent, FunctionComponent, useState } from "react";
import { BMServer, IP, IP_STATUS } from "../model/BMServer";
import {
    EuiButton,
    EuiFlexGroup,
    EuiFlexItem,
    EuiModal,
    EuiModalBody,
    EuiModalFooter,
    EuiModalHeader,
    EuiModalHeaderTitle,
    EuiSelect
} from '@elastic/eui';
import { doc, setDoc, serverTimestamp } from "firebase/firestore";
import { bmServerCollectionName, db, fetchIpInfo, updateIpsForBMServer, proxyNetdataApi } from "../application/FirebaseConfigs";
import { DnsLookup } from "./DnsLookup";

interface IProps {
    server: BMServer | undefined
    showConfigPage: boolean
    setShowConfigPage: React.Dispatch<React.SetStateAction<boolean>>
    onServerChange: (server: BMServer) => void

}
export const BMConfiguration: FunctionComponent<IProps> = (props) => {
    const STATUS = [
        { "value": "ACTIVE", "text": "ACTIVE" },
        { "value": "NEW", "text": "NEW" },
        { "value": "BLOCKED", "text": "BLOCKED" },
        { "value": "DISABLED", "text": "DISABLED" }
    ]
    const [serverCurrentIp, setServerCurrentIp] = useState(props.server?.currentIp);

    function addNewIp() {
        let newIp = prompt("Please enter Newe Ip", "");
        if (newIp != null && newIp.trim().length > 0) {
            processIps(newIp)
                .then(r => { })
                .finally(() => {
                    if (props.server) {
                        fetchIpInfo(props.server)
                            .then(res => {
                                props.onServerChange(res)
                            })
                    }
                })
        }
    }
    async function processIps(ips: string) {
        let ipArray = ips.split(",")
        for (let ip of ipArray) {
            await validateAndAddNewIp(ip.trim().replace(":443", ""))
        }
    }
    async function validateAndAddNewIp(ip: string) {
        let response = await proxyNetdataApi(ip).then(r => r.data as any);
        let traffic = (response["max"] / 1024)
        await setDoc(doc(db, "" + bmServerCollectionName + "/" + props.server?.serverName + "/ips", ip), {
            note: "",
            created_date: serverTimestamp(),
            status: IP_STATUS.NEW
        }, { merge: true })
        return { ip: ip, status: IP_STATUS.NEW }
    }

    function saveServerData() {
        if (props.server) {
            updateIpsForBMServer(props.server)
                .then((res) => {
                    if (res) {
                        props.setShowConfigPage(false)
                    }
                })
                .catch(e => {
                    console.log(e)
                })
        } else {
            alert("Failed to save server details")
        }
    }
    function renderModel() {
        if (!props.showConfigPage || !props.server) {
            return <div />;
        }
        return (<div>
            <EuiModal onClose={() => props.setShowConfigPage(false)}>
                <EuiModalHeader>
                    <EuiModalHeaderTitle>
                        <h1>{props.server?.serverName}</h1>
                    </EuiModalHeaderTitle>
                </EuiModalHeader>
                <EuiModalBody>
                    <EuiFlexGroup style={{ marginBottom: "10px" }} alignItems="center">
                        <EuiFlexItem grow={false}>
                            <label>Server Type:</label>
                        </EuiFlexItem>
                        <EuiFlexItem>
                            <EuiSelect
                                options={[
                                    { value: 'gaming', text: 'Gaming' },
                                    { value: 'streaming', text: 'Streaming' },
                                    { value: 'general', text: 'General' },
                                ]}
                                value={props.server?.serverType || "general"}
                                onChange={(e) => {
                                    if (props.server) {
                                        let updatedServer = { ...props.server, serverType: e.target.value };
                                        props.onServerChange(updatedServer);
                                    }
                                }}
                            />
                        </EuiFlexItem>
                        <EuiFlexItem grow={false}>
                            <label>App:</label>
                        </EuiFlexItem>
                        <EuiFlexItem>
                            <EuiSelect
                                options={[
                                    { value: 'ALL', text: 'ALL' },
                                    { value: 'KARAK', text: 'KARAK' },
                                    { value: 'SPL', text: 'SPL' },
                                ]}
                                value={props.server?.app || "ALL"}
                                onChange={(e) => {
                                    if (props.server) {
                                        let updatedServer = { ...props.server, app: e.target.value };
                                        props.onServerChange(updatedServer);
                                    }
                                }}
                            />
                        </EuiFlexItem>
                    </EuiFlexGroup>
                    {showIPS(props.server)}
                    <div style={{ marginTop: 16, borderTop: "1px solid #D3DAE6", paddingTop: 10 }}>
                        <div style={{ fontSize: 12, marginBottom: 6, color: "#69707D" }}>
                            Dual HTTPS only pairs (not added to ips / old apps)
                        </div>
                        {(props.server.dualHttpsOnlyPairs || []).map(pair => (
                            <EuiFlexGroup key={pair.id} style={{ padding: "3px 5px" }} alignItems="center">
                                <EuiFlexItem>
                                    <input
                                        type="text"
                                        placeholder="primary ip"
                                        value={pair.primaryIp || ""}
                                        onChange={(e) => {
                                            if (!props.server) return;
                                            const pairs = (props.server.dualHttpsOnlyPairs || []).map(p =>
                                                p.id === pair.id ? { ...p, primaryIp: e.target.value.trim() } : p
                                            );
                                            props.onServerChange({ ...props.server, dualHttpsOnlyPairs: pairs });
                                        }}
                                        style={{ width: "100%", padding: "4px" }}
                                    />
                                </EuiFlexItem>
                                <EuiFlexItem>
                                    <input
                                        type="text"
                                        placeholder="secondary ip"
                                        value={pair.secondaryIp || ""}
                                        onChange={(e) => {
                                            if (!props.server) return;
                                            const pairs = (props.server.dualHttpsOnlyPairs || []).map(p =>
                                                p.id === pair.id ? { ...p, secondaryIp: e.target.value.trim() } : p
                                            );
                                            props.onServerChange({ ...props.server, dualHttpsOnlyPairs: pairs });
                                        }}
                                        style={{ width: "100%", padding: "4px" }}
                                    />
                                </EuiFlexItem>
                                <EuiFlexItem grow={false}>
                                    <EuiButton
                                        size="s"
                                        color="danger"
                                        onClick={() => {
                                            if (!props.server) return;
                                            props.onServerChange({
                                                ...props.server,
                                                dualHttpsOnlyPairs: (props.server.dualHttpsOnlyPairs || []).filter(p => p.id !== pair.id)
                                            });
                                        }}
                                    >Remove</EuiButton>
                                </EuiFlexItem>
                            </EuiFlexGroup>
                        ))}
                        <EuiButton
                            size="s"
                            style={{ marginTop: 6 }}
                            onClick={() => {
                                if (!props.server) return;
                                const pairs = [...(props.server.dualHttpsOnlyPairs || [])];
                                pairs.push({
                                    id: "pair_" + Date.now(),
                                    primaryIp: "",
                                    secondaryIp: "",
                                    port: 443,
                                    enabled: true
                                });
                                props.onServerChange({ ...props.server, dualHttpsOnlyPairs: pairs });
                            }}
                        >Add dual HTTPS only pair</EuiButton>
                    </div>
                </EuiModalBody>
                <EuiModalFooter>
                    <EuiButton onClick={addNewIp} fill>Add New Ip</EuiButton>
                    <EuiButton onClick={saveServerData} fill>Save</EuiButton>
                </EuiModalFooter>
            </EuiModal>
        </div>);
    }

    function showIPS(server: BMServer) {
        return <div style={{ display: "flex", flexDirection: "column" }}>
            {server.ips.map(ip => showIP(ip))}
        </div>
    }
    function ipStatusChange(e: ChangeEvent<HTMLSelectElement>, ip: IP) {
        let newStatus: IP_STATUS = IP_STATUS[e.target.value as keyof typeof IP_STATUS];
        props.server?.ips.filter(s => s.ip == ip.ip).forEach(s => s.status = newStatus);
        if (props.server) {
            props.onServerChange(props.server);
        }
    }
    function secondaryIpChange(e: ChangeEvent<HTMLInputElement>, ip: IP) {
        props.server?.ips.filter(s => s.ip == ip.ip).forEach(s => {
            s.secondaryIp = e.target.value.trim();
            s.dualHttpsPort = s.dualHttpsPort || 443;
        });
        if (props.server) {
            props.onServerChange(props.server);
        }
    }
    function showIP(ip: IP) {
        return <EuiFlexGroup key={ip.ip} style={{ display: "flex", flexDirection: "row", padding: "3px 5px" }}>
            <EuiFlexItem style={{ padding: "3px 5px", display: "none" }}>
                <label> <input name={"current_ip"} type={"radio"} checked={serverCurrentIp == ip.ip} onChange={e => { setServerCurrentIp(e.target.value) }} value={ip.ip} /> &nbsp; </label>
            </EuiFlexItem>
            <EuiFlexItem style={{ padding: "3px 5px" }}>
                <label> {ip.ip}</label>
            </EuiFlexItem>
            <EuiFlexItem style={{ padding: "3px 5px" }}>
                <DnsLookup domain={ip.ip} />
            </EuiFlexItem>
            <EuiFlexItem style={{ padding: "3px 5px" }}>
                <input
                    type="text"
                    placeholder="secondary ip"
                    value={ip.secondaryIp || ""}
                    onChange={(e) => secondaryIpChange(e, ip)}
                    style={{ width: "100%", padding: "4px" }}
                />
            </EuiFlexItem>
            <EuiFlexItem>
                <EuiSelect
                    id={ip.status}
                    options={STATUS}
                    value={ip.status}
                    onChange={(e) => ipStatusChange(e, ip)}
                    aria-label="Use aria labels when no actual label is in use"
                    compressed={true}
                />
            </EuiFlexItem>
        </EuiFlexGroup>
    }


    function test(server: BMServer) {
    }
    return (
        <div>
            {props.server && test(props.server)}
            {renderModel()}
        </div>
    )
}
